export default __webpack_public_path__ + "static/media/IVB.52ed1965.svg";